import qs from 'qs';

import { validationParams } from './validateParams';

export function decodeQueryStrings(x) {
	const params = validationParams(x);

	return decodeURIComponent(qs.stringify(params));
}
